// extracted by mini-css-extract-plugin
module.exports = {"HeaderBG":"Crap_HeaderBG__1EN2-"};